const items = [
  "South Indian Breakfast",
  "North Indian Curries",
  "All-Day Continental",
  "Fresh Filter Coffee",
  "Anjuna Beach · Goa",
  "Cafe-Style Classics",
  "Multi-Cuisine Favourites",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-gold/15 bg-surface py-5" data-testid="specialities-marquee">
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {items.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-display text-xl italic text-cream/75">{item}</span>
              <span className="text-sm text-gold">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
